import * as React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { borderSubtle, layoutCardRadius, surfaceCard } from '../../theme/colors';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: surfaceCard,
  padding: '24px',
  border: `1px solid ${borderSubtle}`,
  borderRadius: layoutCardRadius,
  boxSizing: 'border-box',
  width: '100%',
  minWidth: 0,
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
  },
}));

const FormBox = ({ children, ...props }) => {
  return <StyledBox {...props}>{children}</StyledBox>;
};

export default FormBox;
